module.exports = __webpack_public_path__ + "media/video.53c4441d.mp4";